import { Component, Input } from "@angular/core";

@Component({
  selector: "empty-state-card",
  templateUrl: "./empty-state-card.component.html",
  styleUrls: ["./empty-state-card.component.scss"],
  styles: [":host { display: contents; }"],
})
export class EmptyStateCardComponent {
  @Input() message: string = "Nothing to see here yet";
  @Input() isReport: boolean = false;
}
